/* eslint-disable */
/**
 * MockHttpService
 * @class MockHttpService
 */
class MockHttpService {
  /**
   * Sets the cancellation token
   * @param {string} message The cancellation message.
   * @returns {void} void
   * @memberof MockHttpService
   */
  setCancelToken = (message) => {};

  /**
   * Cancels the inflight request
   * @param {string} message The cancellation message.
   * @returns {void} void
   * @memberof MockHttpService
   */
  cancel = (message) => {};

  /**
   * Perform a **GET** request to the given `url`
   * @param {string} url The `url` to request
   * @param {HttpServiceRequestDto} options The required params to make a **POST** request
   * @returns {Promise<any>} The requested resource
   * @memberof MockHttpService
   */
  get = async (url, options) => {
    return;
  };

  /**
   * Perform a **POST** request to the given `url`
   * @param {string} url The `url` to request
   * @param {HttpServiceRequestDto} options The required params to make a **POST** request
   * @returns {Promise<any>} The requested resource
   * @memberof MockHttpService
   */
  post = async (url, options) => {
    return;
  };

  /**
   * Perform a **PUT** request to the given `url`
   * @param {string} url The `url` to request
   * @param {HttpServiceRequestDto} options The required params to make a **PUT** request
   * @returns {Promise<any>} The requested resource
   * @memberof MockHttpService
   */
  put = async (url, options) => {
    return;
  };
}

export default MockHttpService;
